import React from 'react';
import { DifferentiationListItemHeader } from './DifferentiationListItemHeader';
import {
  AssignToGroupsAction,
  DifferentiationListItemSubheader,
  DifferentiationListItemWrapper,
  DifferentiationListWrapper,
  GroupMessageWrapper,
} from './Atoms';
import { ITrajectoryDifferentiation } from 'src/config/api/models/Trajectory';
import { DifferentiationListItemFooter } from './DifferentiationListItemFooter';
import { DifferentiationScreenAction } from '../DifferentiationScreenAction';
import { FontAwesomeSpriteIcon } from 'src/modules/shared/components/FontAwesomeLocal';
import { SpriteIconsLight } from 'src/config/api/models/FontAwesome';
import { useAppSelector } from 'src/modules/shared/hooks/useAppDispatch';

type Props = {
  onChangePreferredVersion: () => void;
  preferredVersion?: string;
  version?: ITrajectoryDifferentiation;
  withPreferenceSelection?: boolean;
  onUpdate: () => void;
  openCallback: (screen: DifferentiationScreenAction, meta?: any) => void;
  trajectoryId?: string;
  refetchTrajectory: (trajectoryId: ITrajectoryDifferentiation['id']) => void;
  isCurrentVersion?: boolean;
};

export const NewDifferentiationListItem: React.FC<Props> = ({
  onChangePreferredVersion,
  preferredVersion,
  version,
  withPreferenceSelection,
  onUpdate,
  openCallback,
  trajectoryId,
  refetchTrajectory,
  isCurrentVersion,
}) => {
  const [openTrajectoryVisible, setOpenTrajectoryVisible] = React.useState(false);
  const currentTrajectoryId = useAppSelector((state) => state.trajectories.currentTrajectoryId);

  return (
    <DifferentiationListWrapper
      onMouseEnter={() => setOpenTrajectoryVisible(true)}
      onMouseLeave={() => setOpenTrajectoryVisible(false)}
      className={isCurrentVersion ? 'selected' : ''}
    >
      <DifferentiationListItemWrapper
        className={`${version?.isOwner ? 'is-collab-hidden' : ''} ${
          isCurrentVersion ? 'selected' : ''
        }`}
      >
        <DifferentiationListItemHeader
          onClick={onChangePreferredVersion}
          version={version}
          preferredVersion={preferredVersion}
          withPreferenceSelection={withPreferenceSelection}
          trajectoryId={trajectoryId as string}
          isCurrentVersion={isCurrentVersion}
        />
        <DifferentiationListItemSubheader>
          <p>{version?.ownerName}</p>
          {` | `}
          <p>
            {version?.createdAt &&
              new Date(version?.createdAt).toLocaleDateString('nl-be').replaceAll('/', '-')}
          </p>
        </DifferentiationListItemSubheader>

        {!version?.isDefaultVersion && (
          <AssignToGroupsAction
            className=""
            onClick={() => openCallback(DifferentiationScreenAction.VISIBILITY, { version })}
            hasGroups={version !== undefined && version.amountOfVisibleGroups > 0}
          >
            <FontAwesomeSpriteIcon
              color={
                version !== undefined && version.amountOfVisibleGroups > 0 ? '#7E7664' : '#BA501C'
              }
              icon={SpriteIconsLight.MAP_SIGN}
              iconSize="xs"
            />
            {version && version?.amountOfVisibleGroups > 0 && (
              <u>
                Toegewezen aan {version?.amountOfVisibleGroups}{' '}
                {version?.amountOfVisibleGroups > 1 ? 'groepen' : 'groep'}
              </u>
            )}
            {version && version?.amountOfVisibleGroups === 0 && (
              <GroupMessageWrapper> {`Nog niet aan groepen toegewezen.`}</GroupMessageWrapper>
            )}
          </AssignToGroupsAction>
        )}
      </DifferentiationListItemWrapper>
      {!version?.isDefaultVersion && (
        <DifferentiationListItemFooter
          version={version}
          openCallback={openCallback}
          openTrajectoryVisible={openTrajectoryVisible}
          refetchTrajectory={refetchTrajectory}
          isCurrentVersion={version?.id === currentTrajectoryId}
        />
      )}
    </DifferentiationListWrapper>
  );
};

export default NewDifferentiationListItem;
